// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "opencc" + "-" + "1cde3c54e23f325bfaf9" + ".chunk.js";
};